module.exports = __webpack_public_path__ + "static/media/dv360-main.153bb819.jpg";